"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AStatisticAction = void 0;
exports.AStatisticAction = ["delete", "reset", "set", "set_fail", "windows_path_fail", "canonical_path_fail", "directory_path_fail", "unzip_fail", "low_mem_fail", "download_fail", "update_fail", "download_0", "download_10", "download_20", "download_30", "download_40", "download_50", "download_60", "download_70", "download_80", "download_90", "download_complete", "decrypt_fail", "checksum_fail", "app_moved_to_foreground", "app_moved_to_background", "update_check", "update_check_complete", "update_check_fail"];
